import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'dashboard-super-admin',
    templateUrl: './dashboard-super-admin.component.html',
    styleUrls: ['./dashboard-super-admin.component.scss'],
    standalone: false
})
export class DashboardSuperAdminComponent implements OnInit {

  constructor() {   }

  ngOnInit(): void {
   
  }

}
